import * as WP from "../wp/index.js";
export class Popup {
  constructor(id, slug, data, title, featuredImage) {
    this.id = id;
    this.slug = slug;
    this.data = data;
    this.title = title;
    this.featuredImage = featuredImage;
  }
  static fromWPJson(json) {
    const id = json.getOr(["databaseId"], null);
    const slug = json.getOr(["slug"], null);
    const title = json.getOr(["title"], null);
    const rawDate = json.getIf(["date"]);
    const rawFeaturedImage = new WP.WPJson(json.getOr(["featuredImage", "node"], {}));
    const date = rawDate.isOk() ? new Date(rawDate.unwrap()) : null;
    const featuredImage = WP.Image.fromWPJson(rawFeaturedImage).unwrapOrNull();
    return new Popup(id, slug, date, title, featuredImage);
  }
}
//# sourceMappingURL=index.js.map
